import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

import { useAppHistoryContext } from 'context';

export const useAppHistory = () => {
  const navigate = useNavigate();
  const { previousRoute } = useAppHistoryContext();

  const goBack = useCallback(
    (fallbackRoute?: string, navigateOptions?: NavigateOptions) => {
      const route = previousRoute || fallbackRoute;
      if (route) {
        navigate(route, navigateOptions);
      }
    },
    [navigate, previousRoute],
  );

  return { goBack };
};
